import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { setAuthentication } from '../../redux/features/authSlice'

import { useDispatch } from 'react-redux'

export const AuthHandler = (props) => {
  const dispatch = useDispatch()
  const [queryParameters] = useSearchParams()
  const navigate = useNavigate()

  const handleHomeRedirect = () => {
    navigate('/home')
  }

  const navigateToLogin = () => {
    navigate('/login')
  }

  useEffect(() => {
    console.log(queryParameters.get('token'))
    console.log(queryParameters.get('userId'))
    const token = queryParameters.get('token')
    const userId = queryParameters.get('userId')
    if (token !== null && token !== 'undefined') {
      dispatch(
        setAuthentication({
          isAuthenticated: true,
          token: token,
          userId: userId,
          error: null,
        }),
      )
      handleHomeRedirect()
    } else {
      dispatch(
        setAuthentication({
          isAuthenticated: false,
          error: queryParameters.get('error'),
          token: null,
          userId: null,
        }),
      )
      navigateToLogin()
    }
  }, [dispatch, props])
  return <></>
}
